import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Typography, TextField, Button, Alert, Box, Tabs, Tab } from '@mui/material';
import { useAuth } from '../auth/Auth';
import "../profile/Profile.css";
import { useNavigate, useLocation } from 'react-router-dom';

const UserProfile = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || 0);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [email, setEmail] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [saveError, setSaveError] = useState('');
  const [saveSuccess, setSaveSuccess] = useState('');

  const [contractor, setContractor] = useState(null);
  const [emails, setEmails] = useState([]);
  const [editingEmails, setEditingEmails] = useState({});
  const [newEmails, setNewEmails] = useState({});
  const [newEmail, setNewEmail] = useState('');
  const [translations, setTranslations] = useState(null);
  const [language, setLanguage] = useState('uk-UA');

  
  const { user } = useAuth();

  useEffect(() => {
    fetchUserData();
    fetchContractorData();
  }, []);

  const fetchUserData = async () => {
    try {
      const userId = user?.user_id;
      if (!userId) {
        setGeneralError(language === 'pl-PL' ? 'Użytkownik nie jest autoryzowany' : 'Користувач не авторизований');
        setLoading(false);
        return;
      }

      const regionResponse = await axios.get(`https://bank2.daolog.net/user-region/${userId}`);
      const userRegion = regionResponse.data.region;
      setLanguage(userRegion);

      const translationsResponse = await axios.get(`https://bank2.daolog.net/translations/userprofile/${userRegion}`);
      setTranslations(translationsResponse.data);

      const response = await axios.get(`https://bank2.daolog.net/user-profile-ppp/${userId}`);
      setUserData(response.data);
      setEmail(response.data.email);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching user data:', error);
      setError('Помилка при отриманні даних користувача');
      setLoading(false);
    }
  };



  
  const fetchContractorData = async () => {
    try {
      const userId = user?.user_id;
      if (!userId) return;

      const response = await axios.get(`https://bank2.daolog.net/user-contractor-ppp/${userId}`);
      setContractor(response.data);
      if (response.data?.id) {
        fetchEmails(response.data.id);
      }
    } catch (error) {
      console.error('Error fetching contractor data:', error);
    }
  };

  const fetchEmails = async (contractorId) => {
    try {
      const { data } = await axios.get(`https://bank2.daolog.net/contractor-emails-s-ppp/${contractorId}`);
      setEmails(data);
    } catch (error) {
      console.error('Error fetching emails:', error);
    }
  };

  const handleSave = async () => {
    try {
      setSaveError('');
      setSaveSuccess('');
      
      const userId = user?.user_id;
      if (!userId) return;

      if (email !== userData.email || newPassword) {
        if (!currentPassword) {
          setSaveError(translations.enterpass);
          return;
        }
        
        await axios.put(`https://bank2.daolog.net/users-ppp/${userId}`, {
          email,
          password: currentPassword,
          newPassword: newPassword || currentPassword
        });
        
        setSaveSuccess(translations.savecorrect);
        setCurrentPassword('');
        setNewPassword('');
        fetchUserData();
      } else {
        setSaveError(translations.nochange);
      }
    } catch (error) {
      setSaveError(error.response?.data?.message || 'Помилка при збереженні даних');
    }
  };

  const handleAddEmail = async () => {
    if (!contractor?.id || !newEmail) {
      return;
    }
    try {
      await axios.post('https://bank2.daolog.net/add-contractor-email-ppp', {
        contractorId: contractor.id,
        email: newEmail
      });
      setNewEmail('');
      fetchEmails(contractor.id);
    } catch (error) {
      console.error('Error adding email:', error);
    }
  };

  const handleDeleteEmail = async (emailId) => {
    try {
      await axios.delete(`https://bank2.daolog.net/delete-email-ppp/${emailId}`);
      fetchEmails(contractor.id);
    } catch (error) {
      console.error('Error deleting email:', error);
    }
  };

  const handleEditEmail = (email) => {
    setEditingEmails(prev => ({
      ...prev,
      [email.id]: true
    }));
    setNewEmails(prev => ({
      ...prev,
      [email.id]: email.email
    }));
  };

  const handleUpdateEmail = async (emailId) => {
    try {
      await axios.put(`https://bank2.daolog.net/update-email-ppp/${emailId}`, {
        email: newEmails[emailId]
      });
      setEditingEmails(prev => ({
        ...prev,
        [emailId]: false
      }));
      fetchEmails(contractor.id);
    } catch (error) {
      console.error('Error updating email:', error);
    }
  };

  if (loading) return <Typography>Завантаження...</Typography>;
  if (error) return <Typography color="error">{error}</Typography>;
  if (!userData) return <Typography>Дані користувача не знайдено</Typography>;

  return (
    <div className="container-about-info-prof" style={{ marginTop: "120px", maxWidth: "800px", margin: "120px auto 0" }}>
      <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)} centered>
        <Tab label={translations.profileTitle} />
        {/* <Tab label="Пошта для рахунків" /> */}
      </Tabs>

      {activeTab === 0 ? (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Typography variant="h5" style={{ marginTop: "30px"}}>{translations.profile}</Typography>
          <div style={{ marginTop: "20px", width: "60%", maxWidth: "400px", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <TextField
              fullWidth
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              style={{ marginBottom: "20px" }}
            />
            <TextField
              fullWidth
              label={translations.currentPassword}
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              margin="normal"
              style={{ marginBottom: "20px" }}
              required={email !== userData.email || newPassword}
            />
            <TextField
              fullWidth
              label={translations.newPassword}
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              margin="normal"
              style={{ marginBottom: "20px" }}
            />
            {saveError && (
              <Alert severity="error" style={{ marginTop: "10px", width: "100%" }}>
                {saveError}
              </Alert>
            )}
            {saveSuccess && (
              <Alert severity="success" style={{ marginTop: "10px", width: "100%" }}>
                {saveSuccess}
              </Alert>
            )}
            <button
              className='download-button'
              onClick={handleSave}
              style={{ marginTop: "20px", marginBottom:"30px" }}
            >
              {translations.save}
            </button>
          </div>
        </div>
      ) : (
        <div style={{ padding: "20px" }}>
          {contractor ? (
            <>
              {/* <Typography variant="h6" style={{ marginBottom: "20px" }}>
                Емейли для відправки рахунків за користування системою клієнта {contractor.name}:
              </Typography>
              <div style={{ marginBottom: "20px" }}>
                <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
                  <input
                    className="input-stl"
                    style={{ flex: 1, padding: "10px", backgroundColor: "rgb(213, 220, 255)" }}
                    type="email"
                    value={newEmail}
                    onChange={(e) => setNewEmail(e.target.value)}
                    placeholder="Введіть новий email який бажаєте додати"
                  />
                  <button
                    className="download-button"
                    onClick={handleAddEmail}
                  >
                    Додати
                  </button>
                </div>
              </div>
              <div>
                {emails.map(email => (
                  <div key={email.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                    {editingEmails[email.id] ? (
                      <>
                        <input
                          className="input-stl"
                          style={{ flex: 1, padding: "10px", backgroundColor: "rgb(213, 220, 255)" }}
                          type="email"
                          value={newEmails[email.id] || ''}
                          onChange={(e) => setNewEmails(prev => ({
                            ...prev,
                            [email.id]: e.target.value
                          }))}
                        />
                        <button
                          className="download-button-g"
                          onClick={() => handleUpdateEmail(email.id)}
                        >
                          Зберегти
                        </button>
                        <button
                          className="download-button-s"
                          onClick={() => setEditingEmails(prev => ({
                            ...prev,
                            [email.id]: false
                          }))}
                        >
                          Скасувати
                        </button>
                      </>
                    ) : (
                      <>
                        <span style={{ flex: 1 }}>{email.email}</span>
                        <button
                          className="download-button"
                          onClick={() => handleEditEmail(email)}
                        >
                          Змінити
                        </button>
                        <button
                          className="download-button"
                          onClick={() => handleDeleteEmail(email.id)}
                        >
                          Видалити
                        </button>
                      </>
                    )}
                  </div>
                ))}
              </div> */}
            </>
          ) : (
            <Typography>Контрагента не знайдено</Typography>
          )}
        </div>
      )}
    </div>
  );
};

export default UserProfile;